export const fixPrecision = (value = '', precision = 0, containsTrailingZero) => {
    let result = value;
    if(result && /^-|\d+(\.\d+)?$/.test(result)) {
        const digitArr = result.split('.');
        let excess = '';
        if(value.indexOf('.') > 0) {
            excess = precision === 0 ? digitArr[1] : digitArr[1].substring(precision);
        }
        if (excess && /^0+$/.test(excess)) {
            return precision === 0 ? digitArr[0] : digitArr[0] + '.' + digitArr[1].substring(0, precision);
        }

        if (containsTrailingZero && !excess) {
            if (result.indexOf('.') > 0) {
                let fixStr = '';
                for(let i = 0; i < precision - digitArr[1].length; i++) {
                    fixStr += '0';
                };
                return result + fixStr;
            } 
            return Number(result).toFixed(precision).toString();
        }
    }
    return result;
};

export const formatSymbol = (value = '',formatType = '') => {
    if(['thousandPercentageSymbol','thousandSymbol'].indexOf(formatType) < 0) {
        return value;
    }
    if(value && /^-|\d+(\.\d+)?$/.test(value)) {
        const digitArr = value.split('.');
        let integer = '';
        integer = digitArr[0].replace(/(?=(?!(\b))(\d{3})+$)/g,',');
        return value.indexOf('.') > 0 ? (integer + '.' + digitArr[1]) : integer;
    }
    return value;
};


// WEBPACK FOOTER //
// ./src/components/util/digitHelper.js